const crudServiceMixin = {
  methods: {
    post (url, model, config = {}) {
      return this.$axios.post(url, model, config)
    },
    delete (url, id) {
      return this.$axios.delete(url + '/' + id)
    },
    get (url, params) {
      return this.$axios.get(url, params)
    },
    getById (url, id) {
      return this.$axios.get(url + '/' + id)
    },
    put (url, model) {
      return this.$axios.put(url, model)
    },
    getWithConfig (config) {
      return this.$axios(config)
    }
  }
}
export default crudServiceMixin
